import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { dynamicUrl,scType,setDateRange,formatDate } from './Function';
import { useDynamicLink } from './DynamicUse';
import { NavLink } from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Container,Row,Col,Image,Card,Placeholder,Nav, Button, ListGroup } from 'react-bootstrap';

const StudentLife = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const deanSw = useDynamicLink(28);
    const[isLoading, setLoading] = useState(true);
    const[Pages,setPages]=useState([]);
    useEffect(()=>
    {
        const SocietyClubPages = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/subMenu/29");
                const result = await response.json();
                setPages(result);
                if( global.config.IsPrint === true ) { console.info('SocietyClubPages : Result',result); }
            } catch (error) 
            {
                console.error('SocietyClubPages : Error', error.message);                
            }
            finally
            {
                setLoading(false);
            }
        };
        SocietyClubPages();
    },[])    
    return (
        <section className="student-life text-center">
            <Container className="py-3 bg-info-subtle vc-profile text-start mb-4">
                <Row className="g-0">
                    <Col sm={4}>
                        <Card className="bg-transparent border-end-0 rounded-0 h-100">
                            <Card.Body className="text-sm-center">
                                <Image src={global.config.uploadPath+'677745882.jpeg'} data-aos="flip-left" data-aos-duration="1500" alt={appLanguage === 'hi' ? "डीन (छात्र कल्याण) फोटो" : "Dean (Student Welfare) Photo"} loading="lazy" fluid />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={8}>
                        <Card className="bg-transparent border-end-0 border-start-0 border-top-0 rounded-0 h-100">
                            <Card.Body className="pt-0 text-dark">
                                <h5 className="mb-4" data-aos="flip-down" data-aos-duration="1000">{appLanguage === 'hi' ? 'डीन (छात्र कल्याण)' : 'Dean (Student Welfare)'}</h5>
                                <h3 className="mb-3 text-capitalize" data-aos="flip-up" data-aos-duration="1500" dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? 'प्रो. मनोज सोनी<br/>डीन (छात्र कल्याण)' : 'Prof. Manoj Soni<br/>Dean (Student Welfare)'}}></h3>
                                <p className="mb-4 text-justify" data-aos="flip-up" data-aos-duration="1000">{appLanguage === 'hi' ? '1948 में भारत की आज़ादी के तुरंत बाद, उस समय के प्रेसिडेंट श्री राधाकृष्णन ने सलाह दी थी कि हर एजुकेशनल इंस्टिट्यूट को स्टूडेंट वेलफेयर का एक डीन अपॉइंट करना चाहिए और स्टूडेंट वेलफेयर के लिए एक ऑफिस बनाना चाहिए। इसका मकसद उस समय स्टूडेंट्स के बीच सामाजिक भेदभाव को कम करना था।' : 'Soon after India’s independence in 1948, the then President, Shri Radhakrishnan, recommended that every educational institute should appoint a Dean of Student Welfare and create an office for student welfare. The aim was to reduce social disparities among students at that time.'}</p>
                                <p className="mb-4 text-justify" data-aos="flip-up" data-aos-duration="1000">{appLanguage === 'hi' ? 'बाद में, 1960 में, यूनिवर्सिटी ग्रांट्स कमीशन (UGC) ने एजुकेशन कमीशन के ज़रिए, सभी यूनिवर्सिटी को फिर से एक डीन स्टूडेंट वेलफेयर ऑफिस बनाने का निर्देश दिया। इसका मकसद स्टूडेंट्स के पूरे विकास में मदद करना, उन्हें उनकी सामाजिक ज़िम्मेदारियों को समझने में मदद करना और उन्हें ऐसे ज़िम्मेदार नागरिक बनने के लिए तैयार करना था जो देश की तरक्की में योगदान दें।' : 'Later, in 1960, the University Grants Commission (UGC), through the Education Commission, again directed all universities to set up a Dean Student Welfare office. The purpose was to support the holistic development of students, help them understand their social responsibilities, and prepare them to become responsible citizens who contribute to the nation’s growth.'}</p>
                                <p className="fw-bold" data-aos="flip-up" data-aos-duration="1000" dangerouslySetInnerHTML={{__html:appLanguage === 'hi' ? 'प्रो. मनोज सोनी<br/>डीन छात्र कल्याण, आईजीडीटीयूडब्लू' : 'Prof. Manoj Soni<br/>Dean Student Welfare, IGDTUW'}}></p>
                                {deanSw && deanSw.map((sp,index)=>(
                                    <NavLink key={index} to={dynamicUrl(sp)} className="btn btn-lg btn-info" data-aos="flip-up" data-aos-duration="1000">
                                        {appLanguage === 'hi' ? 'और पढ़ें' : 'Read more'} <i className="bi bi-arrow-right-short"></i>
                                    </NavLink>
                                ))}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Container className='mb-4 p-0'>
                <Card>
                    <Card.Header className="text-center text-uppercase fs-3">
                        {appLanguage === 'hi' ? 'डिप्टी डीन, छात्र कल्याण' : 'DEPUTY DEAN, STUDENT WELFARE'}
                    </Card.Header>
                    <Card.Body>
                        <div className="text-bg-info bg-info-subtle p-3 rounded mb-3">
                            <div className="d-flex">
                                <div className="bg-primary p-2" data-aos="zoom-in" data-aos-duration="1500" style={{minWidth:"220px"}}>
                                    <Image src={global.config.uploadPath+'199868067.jpg'} data-aos="flip-left" data-aos-duration="1500" alt={appLanguage === 'hi' ? "डिप्टी डीन (छात्र कल्याण) फोटो" : "Deputy Dean (Student Welfare) Photo"} loading="lazy" fluid />
                                </div>
                                <div className="ms-3 text-start">
                                    <div className="ps-3 mb-3 border-start border-4 border-info">
                                        <Card.Title className="fw-bold text-success">{appLanguage === 'hi' ? 'प्रो. (डॉ.) रश्मि अष्ट' : 'Prof. (Dr.) Rashmi Ashtt'}</Card.Title>
                                        <Card.Text className="fw-bold">{appLanguage === 'hi' ? 'डिप्टी डीन छात्र कल्याण, आईजीडीटीयूडब्लू' : 'Deputy Dean Student Welfare, IGDTUW'}</Card.Text>
                                    </div>
                                    <Card.Text className="text-justify" data-aos="flip-up" data-aos-duration="1000">
                                        {appLanguage === 'hi' ? 'इंदिरा गांधी दिल्ली महिला तकनीकी विश्वविद्यालय (आईजीडीटीयूडब्लू) में, डिप्टी डीन, छात्र कल्याण (DSW) का कार्यालय छात्रों के समग्र विकास को बढ़ावा देने में महत्वपूर्ण भूमिका निभाता है। हमारा मानना ​​है कि शिक्षा अकादमिक से परे है, जो समग्र व्यक्तित्व, नेतृत्व गुणों और सामाजिक जिम्मेदारी की गहरी भावना को बढ़ावा देती है।' : 'At Indira Gandhi Delhi Technical University for Women (IGDTUW), the Office of the Deputy Dean, Student Welfare (DSW) plays a pivotal role in promoting the holistic development of students. We believe that education extends beyond academics, fostering well-rounded personalities, leadership qualities, and a deep sense of social responsibility.'}
                                    </Card.Text>
                                    <Card.Text className="text-justify" data-aos="flip-up" data-aos-duration="1000">
                                        {appLanguage === 'hi' ? 'छात्र कल्याण के उप डीन का लक्ष्य एक ऐसा माहौल बनाना है जहाँ छात्र अकादमिक कठोरता, सांस्कृतिक जुड़ाव और पाठ्येतर भागीदारी के संतुलन के माध्यम से अपनी क्षमता का पूरी तरह से पता लगा सकें और उसे साकार कर सकें। छात्र कल्याण विभाग विभिन्न छात्र समाजों और क्लबों में विभिन्न अवसर प्रदान करके इस व्यक्तित्व विकास को सुविधाजनक बनाने के लिए प्रतिबद्ध है। संगीत, नृत्य, नाटक और SPIC MACAY कार्यक्रम जैसी सांस्कृतिक गतिविधियाँ रचनात्मकता और सहयोग को प्रेरित करती हैं, जबकि रोबोल्यूशन जैसी तकनीकी संस्थाएँ छात्रों को उनके पेशेवर और तकनीकी कौशल को बढ़ाने में मदद करती हैं।' : 'The vision of the Deputy Dean of student Welfare is to create an environment where students can fully explore and realize their potential through a balance of academic rigor, cultural engagement, and extracurricular involvement. The Student Welfare Department is committed to facilitating this personality development by offering various opportunities across various student societies and clubs. Cultural activities such as music, dance, drama, and SPIC MACAY events inspire creativity and collaboration, while technical societies like Robolution help students enhance their professional and technical skills.'}
                                    </Card.Text>
                                </div>
                            </div>
                        </div>
                        <Card.Text className="text-justify" data-aos="flip-up" data-aos-duration="1000">
                            {appLanguage === 'hi' ? 'टेक्नोलिटरेटी और क्विज़िंग सोसाइटी जैसी साहित्यिक संस्थाओं के माध्यम से, छात्र आलोचनात्मक सोच, सार्वजनिक भाषण और बौद्धिक जुड़ाव विकसित करते हैं। एनेक्टस, लीनइन और ग्रीनस्फीयर एनवायरनमेंटल सोसाइटी जैसी संस्थाओं द्वारा संचालित सामाजिक जिम्मेदारी और सामुदायिक सेवा पहल छात्रों को स्थिरता और सामाजिक सशक्तिकरण परियोजनाओं में योगदान करने के लिए प्रोत्साहित करती है। ASMI के माध्यम से नेतृत्व कार्यक्रम नेतृत्व और व्यक्तिगत विकास पर ध्यान केंद्रित करते हैं, जबकि सिनर्जी स्पोर्ट्स क्लब और फिटनेस गतिविधियाँ शारीरिक स्वास्थ्य को बढ़ावा देती हैं।' : 'Through literary societies such as Technoliterati and the Quizzing Society, students develop critical thinking, public speaking, and intellectual engagement. Social responsibility and community service initiatives led by societies like Enactus, LeanIn, and Greensphere Environmental Society encourage students to contribute to sustainability and social empowerment projects. Leadership programs through ASMI focus on building leadership and personal development, while Synergy Sports Club and fitness activities promote physical well-being.'}
                        </Card.Text>
                        <Card.Text className="text-justify" data-aos="flip-up" data-aos-duration="1000">
                            {appLanguage === 'hi' ? 'यह सुनिश्चित किया जाता है कि ये सभी गतिविधियाँ छात्रों को सामाजिक रूप से जिम्मेदार, वैश्विक रूप से सक्षम व्यक्ति बनने के लिए तैयार करने की दृष्टि से संरेखित हों, जो न केवल अकादमिक रूप से मजबूत हों, बल्कि जीवन में उत्कृष्टता प्राप्त करने के लिए पारस्परिक और नेतृत्व कौशल भी रखते हों। कार्यालय सभी छात्रों की सुरक्षा और कल्याण के लिए समान रूप से प्रतिबद्ध है, नियमित रूप से आत्मरक्षा कार्यशालाओं, परिसर सुरक्षा ऑडिट और जागरूकता कार्यक्रमों का आयोजन करता है ताकि एक सुरक्षित और सहायक वातावरण सुनिश्चित किया जा सके।' : 'It is ensured that all these activities are aligned with the vision of preparing students to become socially responsible, globally competent individuals who are not only academically strong but also possess the interpersonal and leadership skills to excel in life. The office is equally committed to the safety and well-being of all students, regularly organizing self-defense workshops, campus safety audits, and awareness programs to ensure a safe and supportive environment.'}
                        </Card.Text>
                        <Card.Text className="text-justify" data-aos="flip-up" data-aos-duration="1000">
                            {appLanguage === 'hi' ? 'छात्रों को अपने जुनून का पता लगाने, पेश किए जाने वाले विभिन्न प्रकार के कार्यक्रमों में सक्रिय रूप से भाग लेने और आईजीडीटीयूडब्लू में अपने समय का अधिकतम लाभ उठाने के लिए प्रोत्साहित किया जाता है। हम छात्रों को वैश्विक चुनौतियों का सामना करने के लिए तैयार आत्मविश्वासी, जिम्मेदार और सशक्त व्यक्ति बनने में मदद करते हैं।' : 'Students are encouraged to explore their passions, participate actively in the wide variety of programs offered, and make the most of their time at IGDTUW. We help students to grow into confident, responsible, and empowered individuals ready to meet global challenges.'}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Container>
            <Container className='mb-4 p-0'>
                <Card className='bg-secondary-subtle text-center'>
                    <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1500">
                        {appLanguage === 'hi' ? 'डीएसडब्ल्यू गतिविधियों की झलकियां' : 'Glimpses of DSW Activities'}
                    </Card.Header>
                    <Card.Body>                        
                        <GlimpsesImage sgId="18" />
                    </Card.Body>
                </Card>
            </Container>
            <Container id='StudentWelfare'>
                <h2 className='fs-1 text-uppercase'>
                    {t('StudentsClubsSocieties')}
                </h2>
                <span className="mb-4 sub-heading" style={{width:"225px"}}></span>
                {isLoading ? (
                    <Card className='bg-secondary-subtle mb-4'>
                        <Card.Header className='fs-3'><Placeholder xs={10} /></Card.Header>
                        <Card.Body className='bg-secondary-subtle'>
                            <Row className='g-4 mb-4'>
                                {[...Array(8)].map((_,index)=>(
                                <Col md={3} key={index}>
                                    <Card className='text-bg-info bg-info-subtle shadow h-100' data-aos="flip-up" data-aos-duration="1000">
                                        <Placeholder xs={12} className="card-img-top" style={{minHeight:"150px"}} />
                                        <Card.Body>
                                            <Card.Title><Placeholder xs={10} /></Card.Title>
                                            <Button className='btn btn-info rounded w-50 my-3'><Placeholder xs={10} /></Button>
                                            <div className='text-center'>
                                                <Placeholder style={{width:"30px",height:"30px"}} className="rounded" />
                                                <Placeholder style={{width:"30px",height:"30px"}} className="rounded mx-2" />
                                                <Placeholder style={{width:"30px",height:"30px"}} className="rounded me-2" />
                                                <Placeholder style={{width:"30px",height:"30px"}} className="rounded" />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                ))}
                            </Row>
                            <Button className='btn btn-lg btn-info rounded w-25'><Placeholder xs={10} /></Button>
                        </Card.Body>
                    </Card>
                ) : (
                    <React.Fragment>
                    {Pages.map((sp,index)=>(
                    <Card className='bg-secondary-subtle mb-4' key={index}>
                        <Card.Header className='fs-3 text-uppercase'>{appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name}</Card.Header>
                        <Card.Body>
                            <ClubsList sctId={scType(sp.sp_id)} />
                            <NavLink to={dynamicUrl(sp)} className='btn btn-lg btn-info rounded'>
                                {appLanguage === 'hi' ? 'सभी को देखें' : 'View All'}
                            </NavLink>
                        </Card.Body>
                    </Card>
                    ))}
                    </React.Fragment>
                )}
            </Container>
            <Container className='py-lg-4 py-3'>
                <Row>
                    <Col md={6}>
                        <NoticeBoard />
                    </Col>
                    <Col md={6}>
                        <DswActivities />
                    </Col>
                </Row>            
            </Container>           
        </section>
    );    
}
export default StudentLife;

const GlimpsesImage = ({sgId}) => 
{
    const [open, setOpen] = React.useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const openLightbox = (index) => {setCurrentIndex(index);setOpen(true);};
    const[isLoading, setLoading] = useState(true);
    const[images,setImages]=useState([]);
    const[videos,setVideos]=useState([]);
    useEffect(()=>
    {
        const GetGlimpsesImage = async () => 
        {
            try 
            {
                const imgArray = [];
                const vidArray = [];
                const response = await fetch(global.config.API_URL+"upload/details/0/"+sgId+"/siteGlimpses");
                const result = await response.json();
                result.forEach(up => {
                    if (up.up_ext === '.mp4') {
                        vidArray.push({src:global.config.uploadPath+up.up_fname+up.up_ext});
                    } else {
                        imgArray.push({src:global.config.uploadPath+up.up_fname+up.up_ext});
                    }
                });
                setVideos(vidArray);
                setImages(imgArray);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('GetGlimpsesImage : Result',result); }
            }
            catch (error) 
            {
                console.error('GetGlimpsesImage : Error', error.message);
            }
        };
        GetGlimpsesImage();
    },[sgId])
    return (
        <React.Fragment>
            {isLoading ? ( 
            <Row className='row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 '>
                {[...Array(12)].map((_,index)=>(
                <Col key={index}>
                    <Card className='bg-secondary-subtle border border-3 text-center'>
                        <Placeholder xs={12} style={{height:"200px"}} className="img-fluid" />
                    </Card>
                </Col>
                ))}
            </Row>
            ) : (
                <React.Fragment>
                <Row className='row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 mb-3'>
                {videos.map((up,index)=>( 
                    <Col key={index} >
                        <div className="ratio ratio-16x9 border border-4 rounded overflow-hidden" data-aos="flip-up" data-aos-duration="1000">
                            <video controls>
                                <source src={up.src} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>                    
                    </Col>
                ))}
                </Row>
                <Row className='row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 '>
                {images.map((up,index)=>( 
                    <Col key={index} >                    
                        <Card className='card-glimpses bg-secondary-subtle text-center border-3 position-relative' onClick={() => openLightbox(index)} style={{ cursor: 'pointer' }}>
                            <Card.Img src={up.src} className='img-fluid' />
                            <div className='action-overlay'><i className="bi bi-zoom-in"></i></div>
                        </Card>
                    </Col>
                ))}
                    <Lightbox open={open} close={() => setOpen(false)} slides={images} index={currentIndex} plugins={[Counter,Fullscreen,Slideshow,Zoom,Thumbnails]} />
                </Row>
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

const ClubsList = ({sctId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[Clubs,setClubs]=useState([]);
    useEffect(()=>
    {
        const getClubsByType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"clubs/byTypeLatest/"+sctId);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sc_id + "/scPhoto")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sc_id + "/scPhotoHi")
                                .then(upph => upph.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp,upph]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upph
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].scPhoto = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].scPhotoHi = (el.upph.length > 0) ? global.config.uploadPath + el.upph[0].up_fname + el.upph[0].up_ext : '';                            
                        });
                        setClubs(result);
                    }).catch(error => {
                        console.error('ClubsByType File :', error);
                    });
                }
                else
                {
                    setClubs([]);
                }
                if( global.config.IsPrint === true ) { console.info('ClubsByType : Result',result); }
              
            } catch (error) 
            {
                console.error('ClubsByType : Error', error.message);
            }
        };
        getClubsByType();    
    },[sctId])
    return (
        <Row className='g-4 mb-4 justify-content-center'>
            {Clubs.map((sc,index)=>(
            <Col md={3} key={index}>
                <Card className='text-bg-info bg-info-subtle important-background shadow h-100' data-aos="flip-up" data-aos-duration="1000">
                {appLanguage === 'hi' ? 
                    (
                        sc.scPhotoHi 
                        ? <Card.Img variant="top" src={sc.scPhotoHi} /> 
                        : sc.scPhoto
                            ? <Card.Img variant="top" src={sc.scPhoto} />
                            : <Placeholder xs={12} className="card-img-top" style={{minHeight:"150px"}} />
                    ) : (
                        sc.scPhoto
                        ? <Card.Img variant="top" src={sc.scPhoto} /> 
                        : <Placeholder xs={12} className="card-img-top" style={{minHeight:"150px"}} />
                    )
                }
                    <Card.Body>
                        <Card.Title>{appLanguage === 'hi' ? (sc.sc_display_en === "1" ? sc.sc_name_hi || '' : sc.sc_name_hi || sc.sc_name) : sc.sc_name}</Card.Title>
                        <NavLink to={appLanguage === 'hi' ? `/क्लब-सोसायटी/विवरण/${sc.sc_htaccess_hi || sc.sc_htaccess}` : `/clubs-societies/details/${sc.sc_htaccess}`} className='btn btn-info rounded my-3' target='_blank' rel="noopener noreferrer">
                            {t('ReadMore')}
                        </NavLink>
                        <Nav as="ul" className="d-flex justify-content-center" data-aos="flip-left" data-aos-duration="1500">
                            <Nav.Item as="li">
                                <Nav.Link href={sc.sc_facebook} target="_blank" rel="noopener noreferrer" className="social" style={{background:"#1877f2",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Facebook')+" "+t('Page')}>
                                    <i className="bi bi-facebook"></i>
                                    <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Nav.Link href={sc.sc_instagram} target="_blank" rel="noopener noreferrer" className="social" style={{background:"#f77737",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Instagram')+" "+t('Page')}>
                                    <i className="bi bi-instagram"></i>
                                    <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                </Nav.Link>
                            </Nav.Item>                            
                            <Nav.Item as="li">
                                <Nav.Link href="" target="_blank" rel="noopener noreferrer" className="social" style={{background:"#0a66c2",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Linkedin')+" "+t('Page')}>
                                    <i className="bi bi-linkedin"></i>
                                    <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Nav.Link href="" target="_blank" rel="noopener noreferrer" className="social" style={{background:"#ff0000",color:"#FFF"}} aria-label={t('IGDTUW')+" - "+t('Youtube')+" "+t('Channel')}>
                                    <i className="bi bi-youtube"></i>
                                    <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Card.Body>
                </Card>
            </Col>
            ))}
        </Row> 
    );
}
const NoticeBoard = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const noticePage = useDynamicLink(30);
    const[isLoading, setLoading] = useState(true);
    const[Notices,setNotices]=useState([]);
    useEffect(()=>
    {
        const NoticeLatest = async () => 
        {
            try 
            {
                const { startDate, endDate } = setDateRange(0, 0, 0, 0, 1);
                const callApi = global.config.API_URL + `notices/list/3/none/${startDate}/${endDate}/0`;
                if(global.config.IsPrint) console.info('NoticesList : API', callApi);
                const response = await fetch(callApi);
                const result = await response.json();
                setNotices(result);                
                if( global.config.IsPrint === true ) { console.info('Student Notice : Result',result); }
            }
            catch (error) 
            {
                console.error('Student Notice : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        NoticeLatest(); 
    },[])
    return (
        <Card className='shadow h-100'>
            <h4 className='my-2'>{appLanguage === 'hi' ? 'छात्र सूचना बोर्ड' : 'Student Notice Board'}</h4>
            <span className="mx-auto mb-0 sub-heading"></span>
            {isLoading ? (
                <Card.Body>
                {[...Array(10)].map((_,index) => (
                    <ListGroup.Item key={index} className='d-flex align-items-start px-0'>
                        <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                            <i className="bi bi-calendar3"></i>
                        </span>
                        <div>
                            <Placeholder xs={12} />
                            <Placeholder xs={6} bg="secondary" />
                        </div>
                    </ListGroup.Item>
                ))}
                </Card.Body>
            ) : (
                <React.Fragment>
                {Notices.length === 0 ? (
                    <Card.Body>
                        <big>{t('NoResult')}</big>
                    </Card.Body>
                ) : (
                    <Card.Body className='text-start overflow-hidden overflow-y-auto' style={{height:"300px"}}>
                        <ListGroup variant="flush">
                        {Notices.slice(0,5).map((sn,index)=>(
                            <NavLink key={index} to={appLanguage === 'hi' ? `/नोटिस/विवरण/${sn.sn_htaccess_hi || sn.sn_htaccess}` : `/notice/details/${sn.sn_htaccess}`} className='list-group-item list-group-item-action d-flex align-items-start px-0' target='_blank' rel="noopener noreferrer">
                                <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                    <i className="bi bi-megaphone"></i>
                                </span>
                                <div>
                                    <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (sn.sn_display_en === "1" ? sn.sn_name_hi || '' : sn.sn_name_hi || sn.sn_name) : sn.sn_name }}></div>
                                    <div className='text-secondary'>{formatDate(sn.sn_date)}</div>
                                </div>
                            </NavLink>
                        ))}
                        </ListGroup>
                    </Card.Body>                                  
                )}
                </React.Fragment>
            )}                        
            <Card.Footer className='text-start bg-transparent border-0'>
            {noticePage && noticePage.map((sp,index)=>(
                <NavLink to={dynamicUrl(sp)} className='fw-bold' key={index}>
                    {appLanguage === 'hi' ? 'सभी देखें' : 'View All'} <i className="bi bi-chevron-right"></i>
                </NavLink>
            ))}
            </Card.Footer>
        </Card>
    );
}
const DswActivities = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const dwsPage = useDynamicLink(34);
    const[isLoading, setLoading] = useState(true);
    const[Events,setEvents]=useState([]);
    useEffect(()=>
    {
        const EventsList = async () => 
        {
            try
            {
                setLoading(true);
                const { startDate, endDate } = setDateRange(0, 0, 0, 0, 1);
                const callApi = global.config.API_URL + `events/list/10/0/none/${startDate}/${endDate}/0`;
                if(global.config.IsPrint) console.info('EventsList : API', callApi);
                const response = await fetch(callApi);
                const result = await response.json();
                setEvents(result);
                setLoading(false);
                if (global.config.IsPrint) console.info('EventsList : Result', result);
            } 
            catch (error) 
            {
                console.error('EventsList : Error', error.message);
                setLoading(false);
            }
        };
        EventsList();
    },[])
    return (
        <Card className='shadow h-100'>
            <h4 className='my-2'>{appLanguage === 'hi' ? 'डीएसडब्ल्यू गतिविधियाँ' : 'DSW Activities'}</h4>
            <span className="mx-auto mb-0 sub-heading"></span>
            {isLoading ? (
                <Card.Body>
                {[...Array(10)].map((_,index) => (
                    <ListGroup.Item key={index} className='d-flex align-items-start px-0'>
                        <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                            <i className="bi bi-calendar3"></i>
                        </span>
                        <div>
                            <Placeholder xs={12} />
                            <Placeholder xs={6} bg="secondary" />
                        </div>
                    </ListGroup.Item>
                ))}
                </Card.Body>
            ) : (
                <React.Fragment>
                {Events.length === 0 ? (
                    <Card.Body>
                        <big>{t('NoResult')}</big>
                    </Card.Body>
                ) : (
                    <Card.Body className='text-start overflow-hidden overflow-y-auto' style={{height:"300px"}}>
                        <ListGroup variant="flush">
                        {Events.slice(0,5).map((se,index)=>(
                            <NavLink key={index} to={appLanguage ==='hi' ? `/घटनाक्रम/विवरण/${se.se_htaccess_hi || se.se_htaccess}` : `/event/details/${se.se_htaccess}`} className='list-group-item list-group-item-action d-flex align-items-start px-0' target='_blank' rel="noopener noreferrer">
                                <span className='px-3 py-2 border rounded bg-info-subtle text-info me-3'>
                                    <i className="bi bi-calendar3"></i>
                                </span>
                                <div>
                                    <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (se.se_display_en === "1" ? se.se_name_hi || '' : se.se_name_hi || se.se_name) : se.se_name }}></div>
                                    <div className='text-secondary'>{formatDate(se.se_start_duration)} TO {formatDate(se.se_end_duration)}</div>
                                </div>
                            </NavLink>
                        ))}
                        </ListGroup>
                    </Card.Body>                                  
                )}
                </React.Fragment>
            )}                        
            <Card.Footer className='text-start bg-transparent border-0'>
            {dwsPage && dwsPage.map((sp,index)=>(
                <NavLink to={dynamicUrl(sp)} className='fw-bold' key={index}>
                    {appLanguage === 'hi' ? 'सभी देखें' : 'View All'} <i className="bi bi-chevron-right"></i>
                </NavLink>
            ))}
            </Card.Footer>
        </Card>
    );   
}